<template>
  <div class="search">
    <universal-filters v-if="!hideFilters" v-model="search.filters" class="search__filters"
      :save-to-url="saveFiltersToUrl" />

    <div v-if="$slots.instruction" class="search__instruction">
      <slot name="instruction" />
    </div>

    <p v-if="!search.result.length && !search.isSearching">{{ $t('NOTHING_WAS_FOUND') }}</p>

    <div class="search__result" v-infinite-scroll="onInfiniteScroll">
      <universal-app v-for="app in search.result" :app="app" :shareable="appShareable" @update-filters="updateFilters"
        :key="app.universal_object_identifier">
        <template #custom-action="{ app }">
          <slot name="app-custom-action" :app="app" />
        </template>
      </universal-app>
    </div>

    <div v-if="!search.isSearching && !search.pagination.isLastPage && isPaginationManual" class="search__load-more">
      <v-button type="primary" @click.native="loadNextSearchPage">{{ $t('LOAD_MORE') }}</v-button>
    </div>

    <v-loader v-if="!search.pagination.isLastPage && (!isPaginationManual || search.isSearching)"
      class="search__loading-spinner" :class="{
        'search__loading-spinner_visible': search.isSearching
      }" />
  </div>
</template>

<script>
import infiniteScroll from '@/mixins/infiniteScroll';
import { clone, isEqual } from 'lodash';
import VButton from '@/components/Button.vue';
import UniversalFilters from './UniversalFilters.vue';
import UniversalApp from './UniversalApp.vue';

export default {
  mixins: [infiniteScroll],
  components: { UniversalFilters, UniversalApp, VButton },
  props: {
    appShareable: Boolean,
    saveFiltersToUrl: Boolean,
    hideFilters: Boolean,
    filters: Object,
  },
  data() {
    return {
      search: {
        apiMethod: 'searchIndex',
        filters: {},
        pagination: {
          isManual: false,
        },
      },
    };
  },
  computed: {
    isPaginationManual() {
      return this.search.pagination.page > 2;
    },
  },
  methods: {
    updateFilters(filters) {
      this.$set(this.search, 'filters', {
        ...this.filters,
        ...filters,
      });
    },
    onInfiniteScroll() {
      if (!this.isPaginationManual) {
        this.loadNextSearchPage();
      }
    },
  },
  watch: {
    filters: {
      handler() {
        if (isEqual(this.search.filters, this.filters)) {
          return;
        }

        this.updateFilters(this.filters);
      },
      deep: true,
      immediate: true,
    },
    'search.filters': {
      handler() {
        if (isEqual(this.search.filters, this.filters)) {
          return;
        }

        this.$emit('update:filters', clone(this.search.filters));
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.search {
  container: search / inline-size;

  @include notebook {
    container-type: normal;
  }

  &__filters,
  &__instruction {
    margin-bottom: 15px;
  }

  &__result {
    display: grid;
    grid-template-columns: 1fr;
    gap: 15px;
    max-width: 100%;

    /* Use media query instead of includes to ensure proper breakpoints */
    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1024px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  &__loading-spinner {
    margin-top: 15px;
  }

  &__loading-spinner {
    opacity: 0;

    &_visible {
      opacity: 1;
    }
  }

  &__load-more {
    text-align: center;
    margin-top: 20px;

    &_invisible {
      opacity: 0;
    }
  }
}
</style>
